export default __webpack_public_path__ + "static/Idea@992_2x-b4aa46e03e5c464ac5461f88fb660a5b.png";